
import Header from "@/components/elements/Header.vue";
import FanzoneTitle from "@/components/title/FanzoneTitle.vue";
import Stream from "@/components/elements/Stream.vue";
import Subtitle from "@/components/elements/Subtitle.vue"
import HeroEvent from "@/components/elements/HeroEvent.vue";
import TeamTitle from "@/components/title/TeamTitle.vue";
import {Options, Vue} from "vue-class-component";
import Settings from "@/services/Settings";

@Options({
  components: {
    Stream,
    FanzoneTitle,
    Header,
    HeroEvent,
    Subtitle,
    TeamTitle
  },
})
export default class EventFanzone extends Vue {
  private eventId: string | null = null;
  private projectId: string | null = null;
  private host: string | null = null;
  private loader = false;
  private loaderFeedData = false;
  private event: any = {};
  private page = 1;
  private totalPages = 1;
  private limit = 12;
  private total = 0;
  private feedData = [];
  private keywords = [];
  private config = {};

  loadData(): void {
    if (this.loader) return;
    this.loader = true;
    this.$http.get(this.host + '/public/events/' + this.eventId, {
      params: {}
    }).then((response) => {
      this.event = response.data;
      this.projectId = response.data.projectStreamId;
      this.keywords = response.data.keywords;
      this.config = response.data.config;
      this.loadFeedData();

      this.loader = false;
    }, () => {
      this.loader = false;
    });
  }

  loadFeedData(): void {
    if (this.loaderFeedData) return;
    this.loaderFeedData = true;
    this.$http.get(this.host + '/public/results/' + this.projectId +'?sort_by=time%20desc&page='+ this.page +'&limit=' + this.limit, {
      params: {}
    }).then((response) => {
      this.feedData = [
        ...this.feedData,
        ...response.data.inline.resources
      ] as never[];
      this.total = response.data.total;
      this.loaderFeedData = false;
      this.totalPages = response.data.pages;
    }, () => {
      this.loaderFeedData = false;
    });
  }

  paginateData(): void {
    this.page+=1;
    this.loadFeedData();
  }

  mounted(): void {
    this.eventId = this.$route.params.eventId as string;
    const settings = new Settings();
    this.host = settings.getSetting('apiHost');
    this.loadData();
  }
}

